import { memo } from 'react';
import ThumbnailHRS from './thumbnailHRS';
import useHrsEventPreviewStrip from './useHrsEventPreviewStrip';

export type HrsEventPreviewStripProps = {
  channels: number[];
  id: string;
  width: number;
  height: number;
  ecgDataMap: any;
  overlayContent?: any;
  start?: any;
  stop?: any;
  highPass?: any;
  gain?: any;
  // passed by dailySummaryHrsThumbnail.tsx but never read here (pre-existing dead props)
  studyId?: any;
  profileId?: any;
  timezoneOffset?: any;
  isLoading?: boolean;
};

/**
 * Draws the small ECG waveform preview shown beside a min or max heart-rate reading. useHrsEventPreviewStrip supplies the ECG samples, beat markers and HES beat status, and the ThumbnailHRS canvas is rendered only once at least one ECG sample is available.
 *
 * @param overlayContent - Optional node drawn on top of the waveform; defaults to null.
 * @param props - Remaining strip settings such as id, time window, channels, high-pass, gain and canvas size.
 * @returns The rendered thumbnail canvas, or false while no ECG data has loaded.
 */
const HrsEventPreviewStrip = ({ overlayContent = null, ...props }: HrsEventPreviewStripProps) => {
  const { ecgData, beatMarkers, hesBeatStatus } = useHrsEventPreviewStrip(props);

  return (
    ecgData?.length > 0 && (
      <ThumbnailHRS
        id={props.id}
        overlayContent={overlayContent}
        ecgData={ecgData}
        beatMarkers={beatMarkers}
        hesBeatStatus={hesBeatStatus}
        channels={props.channels}
        highPass={props.highPass}
        width={props.width}
        height={props.height}
        gain={props.gain}
      />
    )
  );
};

export default memo(HrsEventPreviewStrip);
